export const getFlightWithSegmentGroup = (flight, group, subsidized) => {
    return {
        id: flight.id,
        segments: group.segments.map(segment => flight.segments[segment.id]),
        pricesForFareGroups: [
            {
                fareFamily: group.fareFamily
                    ? Object.assign({}, group.fareFamily) : null,
                prices: [
                    {
                        originalPrice: group.price,
                        price: group.price,
                        priceInMiles: group.priceInMiles,
                        flight: {
                            fares: [],
                            canBePaidByMiles: false,
                            id: flight.id,
                            subsidized
                        }
                    }
                ]
            }
        ]
    };
};
